import styled from '@2pulse/responsive';
import { normalize } from '@app/helpers';
import { row } from '@app/style';

export const Header = styled.View<{ expanded?: boolean }>(({ theme, props }) => ({
  ...row,
  height: props.expanded ? theme.sizes.headerHeight : theme.sizes.headerHeight,
  paddingLeft: normalize(34) + theme.sizes.sidebarWidth,
  paddingBottom: normalize(8),
  paddingRight: normalize(34),
  alignItems: 'flex-end',
  transition: 'height 0.3s ease-in-out',
  flexWrap: 'wrap',
  // backgroundColor: '#F8FCFD',
}));
